import { YituLogoImg } from "components/YituLogo";
import * as _ from "lodash";
import React from "react";
import { Link } from "react-router-dom";
import { prefix } from "../../config";
import { DetailNewsList } from "../../PortalHome/components/NewsWall";
import { PortalPageContainer } from "../../PortalHome/components/PortalPageContainer";
import "./index.scss";
import { NewsData } from "./model";
import { newsData } from "./newsData";

interface IProps {
  match: { params: { id: string } };
}

export default class NewsDetail extends React.PureComponent<IProps> {
  state: NewsData = {
    title: "",
    icon: "",
    date: "",
    contentStream: [],
    recommendations: []
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  render() {
    const newsId = this.props.match.params.id;
    const { title, date, contentStream, previous, next } = newsData[newsId];

    return (
      <PortalPageContainer>
        <div className="NewsDetail-content">
          <div className="NewsDetail-header">
            <div className="NewsDetail-icon">
              <YituLogoImg.Cn
                style={{
                  width: 96,
                  height: 96
                }}
              />
            </div>
            <div className="NewsDetail-title">
              <p className="NewsDetail-title-paragraph">{title}</p>
              <span className="NewsDetail-date">{date}</span>
            </div>
          </div>
          <div className="NewsDetail-body">
            <div className="NewsDetail-share" />
            <div className="NewsDetail-middle">
              <div className="NewsDetail-info">
                <div className="NewsDetail-section">
                  {_.map(contentStream, content => {
                    switch (content.type) {
                      case "image":
                        return (
                          <img
                            className="NewsDetail-img"
                            alt="NewsDetail-img"
                            src={content.content}
                          />
                        );
                      case "text":
                        return (
                          <p className="NewsDetail-text">{content.content}</p>
                        );
                      case "text-bold":
                        return (
                          <p className="NewsDetail-text-bold">
                            {content.content}
                          </p>
                        );
                      case "text-small":
                        return (
                          <p className="NewsDetail-text-small">
                            {content.content}
                          </p>
                        );
                      case "paragraph":
                        return (
                          <p className="NewsDetail-paragraph">
                            {content.content}
                          </p>
                        );
                      case "blank":
                        return (
                          <div
                            className={`NewsDetail-blank-${content.content}`}
                          />
                        );
                      default:
                        return <div />;
                    }
                  })}
                </div>
              </div>
              {previous ? (
                <div className="NewsDetail-next">
                  <Link to={`${prefix}/news/${previous.id}`}>
                    上一篇：{previous.title}
                  </Link>
                </div>
              ) : null}
              {next ? (
                <div className="NewsDetail-next">
                  <Link to={`${prefix}/news/${next.id}`}>
                    下一篇：{next.title}
                  </Link>
                </div>
              ) : null}
            </div>
            <div className="NewsDetail-recommendation">
              <p className="NewsDetail-recommendation-title">相关推荐</p>
              <DetailNewsList />
            </div>
          </div>
        </div>
      </PortalPageContainer>
    );
  }
}
